export const galleryPreview = [
    {
        title: 'Drippy Rugs and his rugs',
        alt: 'Drippy Rugs and his rugs',
        src: require('../../../img/gallery/preview/drippy_rugs_and_his_rugs_mini.jpg'),
    },
    {
        title: 'Tufted Rug cow and milk',
        alt: 'Tufted Rug cow and milke',
        src: require('../../../img/gallery/preview/tufted_rug_cow_and_milk_mini.jpg'),
    },
    {
        title: 'Drippy Rugs with his cat',
        alt: 'Drippy Rugs with his cat',
        src: require('../../../img/gallery/preview/drippy_rugs_1_mini.jpg'),
    },
    {
        title: 'Koberec mladiladijazz',
        alt: 'Koberec mladiladijazz',
        src: require('../../../img/gallery/preview/koberec_mladiladijazz_mini.jpg'),
    },
    {
        title: 'Tufted Rug Booty',
        alt: 'Tufted Rug Booty',
        src: require('../../../img/gallery/preview/tufted_rug_booty_mini.jpg'),
    },
    {
        title: 'Tufted Rug paris grafitti',
        alt: 'Tufted Rug paris grafitti',
        src: require('../../../img/gallery/preview/tufted_rug_paris_grafitti_mini.jpg'),
    },
    {
        title: 'Tufted Rug Dog',
        alt: 'Tufted Rug Dog',
        src: require('../../../img/gallery/preview/tufted_rug_dog_1_mini.jpg'),
    },
    {
        title: 'Custom Tufted Rug',
        alt: 'Custom Tufted Rug',
        src: require('../../../img/gallery/preview/custom_tufted_rug_1_mini.jpg'),
    },
    {
        title: 'Koberec pattern - Nik Tendo a NobodyListen',
        alt: 'Koberec pattern - Nik Tendo a NobodyListen',
        src: require('../../../img/gallery/preview/koberec_pattern_niktendo_a_nobodylisten_mini.jpg'),
    },
    {
        title: 'Tufted rug Travis Scott',
        alt: 'Tufted rug Travis Scott',
        src: require('../../../img/gallery/preview/tufted_rug_travis_scott_pink_mini.jpg'),
    },
    {
        title: 'Tufted Rug Newman Georgia',
        alt: 'Tufted Rug Newman Georgia',
        src: require('../../../img/gallery/preview/tufted_rug_newman_georgia_mini.jpg'),
    },
    {
        title: 'Drippy Rugs and Almo Vintage Prague',
        alt: 'Drippy Rugs and Almo Vintage Prague',
        src: require('../../../img/gallery/preview/drippy_rugs_and_almo_vintage_prague_mini.jpg'),
    },
    {
        title: 'Tufted rug street block barbershop',
        alt: 'Tufted rug street block barbershop',
        src: require('../../../img/gallery/preview/tufted_rug_street_block_barbershop_mini.jpg'),
    },
    {
        title: 'Koberec pro firmu mvtzb',
        alt: 'Koberec pro firmu mvtzb',
        src: require('../../../img/gallery/preview/koberec_mvtzb_mini.jpg'),
    },
    {
        title: 'Tufted rug Connor Mcgregor',
        alt: 'Tufted rug Connor Mcgregor',
        src: require('../../../img/gallery/preview/tufted_rug_connor_mcgregor_mini.jpg'),
    },
    {
        title: 'Tufted rug fuck off',
        alt: 'Tufted rug fuck off',
        src: require('../../../img/gallery/preview/tufted_rug_fuck_off_1_mini.jpg'),
    },
    {
        title: 'Tufted rug Almo Vintage Prague',
        alt: 'Tufted rug Almo Vintage Prague',
        src: require('../../../img/gallery/preview/tufted_rug_almo_vintage_prague_mini.jpg'),
    },
]

export const galleryNormal = [
    {
        title: 'Drippy Rugs and his rugs',
        alt: 'Drippy Rugs and his rugs',
        src: require('../../../img/gallery/normal/drippy_rugs_and_his_rugs.jpg'),
    },
    {
        title: 'Tufted Rug cow and milk',
        alt: 'Tufted Rug cow and milke',
        src: require('../../../img/gallery/normal/tufted_rug_cow_and_milk.jpg'),
    },
    {
        title: 'Drippy Rugs with his cat',
        alt: 'Drippy Rugs with his cat',
        src: require('../../../img/gallery/normal/drippy_rugs_1.jpg'),
    },
    {
        title: 'Koberec mladiladijazz',
        alt: 'Koberec mladiladijazz',
        src: require('../../../img/gallery/normal/koberec_mladiladijazz.jpg'),
    },
    {
        title: 'Tufted Rug Booty',
        alt: 'Tufted Rug Booty',
        src: require('../../../img/gallery/normal/tufted_rug_booty.jpg'),
    },
    {
        title: 'Tufted Rug paris grafitti',
        alt: 'Tufted Rug paris grafitti',
        src: require('../../../img/gallery/normal/tufted_rug_paris_grafitti.jpg'),
    },
    {
        title: 'Tufted Rug Dog',
        alt: 'Tufted Rug Dog',
        src: require('../../../img/gallery/normal/tufted_rug_dog_1.jpg'),
    },
    {
        title: 'Custom Tufted Rug',
        alt: 'Custom Tufted Rug',
        src: require('../../../img/gallery/normal/custom_tufted_rug_1.jpg'),
    },
    {
        title: 'Koberec pattern - Nik Tendo a NobodyListen',
        alt: 'Koberec pattern - Nik Tendo a NobodyListen',
        src: require('../../../img/gallery/normal/koberec_pattern_niktendo_a_nobodylisten.jpg'),
    },
    {
        title: 'Tufted rug Travis Scott',
        alt: 'Tufted rug Travis Scott',
        src: require('../../../img/gallery/normal/tufted_rug_travis_scott_pink.jpg'),
    },
    {
        title: 'Tufted Rug Newman Georgia',
        alt: 'Tufted Rug Newman Georgia',
        src: require('../../../img/gallery/normal/tufted_rug_newman_georgia.jpg'),
    },
    {
        title: 'Drippy Rugs and Almo Vintage Prague',
        alt: 'Drippy Rugs and Almo Vintage Prague',
        src: require('../../../img/gallery/normal/drippy_rugs_and_almo_vintage_prague.jpg'),
    },
    {
        title: 'Tufted rug street block barbershop',
        alt: 'Tufted rug street block barbershop',
        src: require('../../../img/gallery/normal/tufted_rug_street_block_barbershop.jpg'),
    },
    {
        title: 'Koberec pro firmu mvtzb',
        alt: 'Koberec pro firmu mvtzb',
        src: require('../../../img/gallery/normal/koberec_mvtzb.jpg'),
    },
    {
        title: 'Tufted rug Connor Mcgregor',
        alt: 'Tufted rug Connor Mcgregor',
        src: require('../../../img/gallery/normal/tufted_rug_connor_mcgregor.jpg'),
    },
    {
        title: 'Tufted rug fuck off',
        alt: 'Tufted rug fuck off',
        src: require('../../../img/gallery/normal/tufted_rug_fuck_off_1.jpg'),
    },
    {
        title: 'Tufted rug Almo Vintage Prague',
        alt: 'Tufted rug Almo Vintage Prague',
        src: require('../../../img/gallery/normal/tufted_rug_almo_vintage_prague.jpg'),
    },
]
